module.exports = __webpack_public_path__ + "static/media/harris_2.eb800240.jpg";